import VerticalTabsDefaultProps from "segments/desktop/core-components/vertical-tabs/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "/styles/colors";

const { tabs, defaultActiveTabIndex, title, ...rest } = VerticalTabsDefaultProps;

const titleDefaultProps = {
  topic: {},
  title: "Streamline workflows, from operational  planning to supply chain management",
  body: "",
  textAlign: "center",
  spaceFromParagraph: "8px"
};

const asset = {
  position: "center",
  fitToContainer: true,
  image: {
    src: "/static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
  }
};

export default {
  ...rest,
  titles: [
    {
      tabsTitle: "Goals",
      tabs: [
        { tabLabel: "Goal management", asset, title: titleDefaultProps },
        { tabLabel: "High-level project plan", asset, title: titleDefaultProps },
        { tabLabel: "Projects overview", asset, title: titleDefaultProps },
        { tabLabel: "Workload management", asset, title: titleDefaultProps },
        { tabLabel: "Strategic planning", asset, title: titleDefaultProps },
        { tabLabel: "Resource allocation", asset, title: titleDefaultProps }
      ]
    },
    {
      tabsTitle: "Projects",
      tabs: [
        { tabLabel: "Project management", asset, title: titleDefaultProps },
        { tabLabel: "Operations processes", asset, title: titleDefaultProps },
        { tabLabel: "Request management", asset, title: titleDefaultProps },
        { tabLabel: "Client projects", asset, title: titleDefaultProps }
      ]
    },
    {
      tabsTitle: "Tasks",
      tabs: [
        { tabLabel: "Task management", asset, title: titleDefaultProps },
        { tabLabel: "Create a workflow", asset, title: titleDefaultProps }
      ]
    }
  ],
  backgroundColor: "light-blue-video-background",
  paddingTop: 0,
  paddingBottom: 0,
  tabsPosition: positionTypes.TOP_LEFT,
  minHeight: 500,
  addTimeline: true,
  addTabIndicator: false,
  fullBackground: true,
  lineColor: Colors[WHITE_COLOR_NAME]
};
